import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import SplitText from '../SplitText';

const Location = ({ content }) => {
  const { t } = useTranslation('full_page');

  const { text, latitude, longitude } = content;

  const mapUrl = latitude && longitude
    ? `https://www.google.com/maps?q=${latitude},${longitude}&hl=es;z=14&output=embed`
    : null;

  return (
    <SplitText>
      {
        text
          ? (
            <span>{text}</span>
          )
          : (
            mapUrl
              ? (
                <iframe
                  title={t('send_location_iframe_arial_label', { latitude, longitude })}
                  width="100%"
                  height="250"
                  style={{ border: 0 }}
                  src={mapUrl}
                  allowFullScreen
                />
              )
              : (
                <p>{t('send_location_not_available')}</p>
              )
          )
      }
    </SplitText>
  );
};

Location.propTypes = {
  content: PropTypes.shape({
    text: PropTypes.number,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }).isRequired
};

export default Location;
